import { I18NextService } from 'angular-i18next';

export function getTableHeaders(i18: I18NextService) {
  return [
    {
      name: i18.t('licenses:prepayment.awsTable.headers.storageName', { format: 'title' }),
      gridColSize: '6fr',
      gridColMin: '120px'
    },
    {
      name: i18.t('licenses:prepayment.awsTable.headers.paymentPeriod', { format: 'title' }),
      gridColSize: '3fr',
      gridColMin: '150px',
      isGridColumn: false,
      overflow: true
    },
    {
      name: i18.t('licenses:prepayment.awsTable.headers.storageVolume', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      overflow: false
    },
    {
      name: i18.t('licenses:prepayment.awsTable.headers.deletedData', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      overflow: true
    },
    {
      name: i18.t('licenses:prepayment.awsTable.headers.costPerGb', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      overflow: true
    },
    {
      name: i18.t('licenses:prepayment.awsTable.headers.totalCost', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-end',
      overflow: true
    },
  ];
}
